import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';

function UserDetails({ user }) {
  const [subscriptions, setSubscriptions] = useState([]);
  const [userDetails, setUserDetails] = useState(null);

  const getUserSubscriptions = async (userId) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_HOSTNAME}/admin/get-all-details`,
        { userId }
      );

      console.log('API Response:', response);  

      if (response.status === 200 && response.data) {
        const userData = response.data.data[0];
        if (userData) {
          setUserDetails(userData); 
          if (userData.subscriptions && Array.isArray(userData.subscriptions)) {
            setSubscriptions(userData.subscriptions);
          } else {
            console.error('No subscriptions found in the user details.');
            setSubscriptions([]);
          }
        }
      } else {
        console.error('Error fetching subscription details: Invalid response format');
        setSubscriptions([]);
      }
    } catch (error) {
      console.error('Error fetching subscription details:', error);
      setSubscriptions([]);
    }
  };

  useEffect(() => {
    if (user && user.user_id) {
      getUserSubscriptions(user.user_id);
    }
  }, [user]);

  const imageUrl = userDetails?.profile_image
  ? `${process.env.REACT_APP_API_HOSTNAME.replace(/(:\d+)?$/, '')}/config/uploads/${userDetails.profile_image}`
  : '../StyledComponents/img/logo (11).png';

console.log('Generated Image URL:', imageUrl);


  if (!userDetails) {
    return <div>Loading...</div>;
  }

  return (
    <div className="userdetail-main">
      <div className="middle">
        <div className="middle-inner">
          <div className="right">
            <div className="rleft">
              <div className="title">
                <h2
                  onClick={() => {
                    if (window.history.length > 1) {
                      window.history.back(); 
                    } else {
                      window.location.href = '/whooska/admin/dashboard'; 
                    }
                  }}
                  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
                >
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    style={{
                      fontSize: '34px',
                      marginRight: '10px',
                      backgroundColor: '#F7812A',
                      color: 'white',
                      width: '30px',
                      height: '20px',
                      padding: '10px',
                      borderRadius: '10%',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  />
                  User Details
                </h2>


                <div className="user-name">
                  <div className="img-content">
                    <img src={imageUrl} alt="profile_image" />
                  </div>
                  <div className="text">
                    <h2>{userDetails.name}</h2>
                    <h4>{user.status}</h4>
                  </div>
                </div>

                <div className="content">
                  <div className="content-top">
                    <div className="email">
                      <div className="heading">Email</div>
                      <div>{userDetails.email}</div>
                    </div>
                    <div className="email">
                      <div className="heading">Phone</div>
                      <div>{userDetails.mobile_number}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="rrghit">
              <div className="title">
                <h2>Subscription List</h2>
              </div>

              <div className="table">
                <table>
                  <thead>
                    <tr>
                      <th>Plan Name</th>
                      <th>Purchase Date</th>
                      <th>Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subscriptions && subscriptions.length > 0 ? (
                      subscriptions.map((subscription, index) => {
                        const date = new Date(subscription.created_at * 1000);
                        const formattedDate = date.toLocaleDateString('en-GB');

                        return (
                          <tr key={index}>
                            <td>{subscription.plan_name}</td>
                            <td>{formattedDate}</td>
                            <td>{subscription.plan_price}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="3">No subscriptions found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserDetails;
